import React from 'react';

import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';

export const SummarizeIcon = () => (
	<AiGenerativeTextSummaryIcon label="" color="currentColor" spacing="spacious" />
);
